import React from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import {injectIntl} from 'react-intl';
import LabelNamed from '../../../forecast-app/shared/components/labels/label_named';

const SuggestedLabel = ({viewer, taskLabelNames, allLabels, addLabelToTask, isProjectLocked, cy}) => {
	if (viewer.company.availableMLModels && !viewer.company.availableMLModels.labelModel) return null;
	let suggestedLabels = [];

	const allSuggestedLabels = viewer.task
		? viewer.task.labelSuggestion.map(labelId => {
				return allLabels.find(label => label.id === labelId);
		  })
		: [];

	suggestedLabels = allSuggestedLabels
		.filter(suggestedLabel => !taskLabelNames.includes(suggestedLabel.name.toLowerCase()))
		.slice(0, 5)
		.map(suggestedLabel => {
			const {id, name} = suggestedLabel;
			return {
				id,
				name,
			};
		});
	return suggestedLabels.map(suggestedLabel => <LabelNamed label={suggestedLabel} addSuggestedLabel={addLabelToTask} isProjectLocked={isProjectLocked} cy={cy} />);
};

const SuggestedLabelQuery = graphql`
	query SuggestedLabel_Query($taskId: ID) {
		viewer {
			actualPersonId
			component(name: "suggested_label")
			...SuggestedLabel_viewer @arguments(taskId: $taskId)
		}
	}
`;

export {SuggestedLabelQuery};

export default injectIntl(
	createFragmentContainer(SuggestedLabel, {
		viewer: graphql`
			fragment SuggestedLabel_viewer on Viewer @argumentDefinitions(taskId: {type: "ID"}) {
				company {
					availableMLModels {
						labelModel
					}
				}
				task(id: $taskId) {
					labelSuggestion
				}
			}
		`,
	})
);
